<mat-toolbar color="accent">Edit Merchant</mat-toolbar>

<mat-dialog-content>
  <div class="flex flex-col gap-4 py-4">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Merchant Display Name</mat-label>
      <input
        matInput
        [formControl]="nameControl"
        [placeholder]="data.merchant.providerName"
      />
    </mat-form-field>

    <pr-practitioner-selector
      allowEmpty
      label="Associated Practitioner"
      emptyLabel="None"
      [staffer]="
        !data.merchant.practitionerRef
          ? undefined
          : (data.merchant.practitionerRef
            | map: globalStore.getStaffer$ : globalStore
            | async)
      "
      (stafferSelected)="practitionerSelected($event?.ref)"
    />
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
    <button type="button" mat-flat-button color="primary" (click)="save()">
      Save
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
